import script from "./Review.vue?vue&type=script&setup=true&lang=js"
export * from "./Review.vue?vue&type=script&setup=true&lang=js"

import "./Review.vue?vue&type=style&index=0&id=732bb92d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732bb92d"]])

export default __exports__